(() => {
  const root = window.Shopify?.routes?.root || '/';
  let opener;
  const lightbox = document.querySelector('#photo-modal');
  const drawer = document.createElement('dialog');
  drawer.className = 'cart-dialog'; drawer.setAttribute('aria-label','Je winkelmand');
  document.body.append(drawer);
  const close = modal => { modal.close(); opener?.focus(); };
  async function showCart(button) {
    const response = await fetch(root + '?sections=cart-drawer');
    if (!response.ok) throw new Error('Je winkelmand kon niet worden geladen.');
    const sections = await response.json();
    if (!sections['cart-drawer']) throw new Error('Je winkelmand kon niet worden geladen.');
    drawer.innerHTML = sections['cart-drawer'];
    const count = drawer.querySelector('[data-current-cart-count]')?.dataset.currentCartCount;
    if (count !== undefined) document.querySelectorAll('[data-cart-count]').forEach(n => n.textContent=count);
    opener=button; if (!drawer.open) drawer.showModal();
  }
  document.addEventListener('submit', async event => {
    const form=event.target.closest('[data-product-form]'); if (!form) return;
    event.preventDefault();
    const button=form.querySelector('[data-add-button]'); if (button.disabled) return;
    const error=form.querySelector('.product-error'); const success=form.querySelector('.product-success');
    error.textContent=''; success.textContent=''; button.disabled=true;
    const label=button.innerHTML; button.textContent='Toevoegen…';
    let added=false;
    try {
      const response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const result=await response.json();
      if (!response.ok) throw new Error(result.description || 'Toevoegen is niet gelukt. Controleer je winkelmand en probeer opnieuw.');
      added=true;
      await showCart(button);
    } catch (e) {
      if (added) {
        success.textContent='Toegevoegd. ';
        const link=document.createElement('a'); link.href=root+'cart'; link.textContent='Bekijk je winkelmand'; link.className='text-link'; success.append(link);
      } else error.textContent=e.message || 'Controleer je verbinding en je winkelmand voordat je opnieuw probeert.';
    } finally {button.innerHTML=label;button.disabled=false;}
  });
  document.addEventListener('click', async event => {
    const button=event.target.closest('button,a'); if(!button)return;
    if(button.matches('.cart-btn')) {
      event.preventDefault(); try {await showCart(button);} catch {location.href=button.href;} return;
    }
    if(button.dataset.quantity) {
      const input=button.closest('.quantity').querySelector('input');
      const min=Number(input.min)||0;const max=input.max?Number(input.max):999;
      input.value=Math.max(min,Math.min(max,(Number(input.value)||min)+Number(button.dataset.quantity)));
      input.dispatchEvent(new Event('change',{bubbles:true})); return;
    }
    if(button.dataset.image) {
      const gallery=button.closest('.gallery'), main=gallery.querySelector('.gallery-main img'), thumb=button.querySelector('img');
      main.src=thumb.src; main.srcset=thumb.srcset; main.alt=thumb.alt;
      gallery.querySelectorAll('.thumb').forEach(t=>t.setAttribute('aria-pressed',String(t===button))); return;
    }
    if(button.hasAttribute('data-cookie-preferences')) {
      if(window.privacyBanner?.showPreferences) {
        try {await window.privacyBanner.showPreferences();} catch {document.querySelector('[data-cookie-help]').hidden=false;}
      } else document.querySelector('[data-cookie-help]').hidden=false;
      return;
    }
    switch(button.dataset.action) {
      case 'menu': {const menu=document.querySelector('#mobile-nav'),open=menu.classList.toggle('open');button.setAttribute('aria-expanded',String(open));button.setAttribute('aria-label',open?'Menu sluiten':'Menu openen');break;}
      case 'zoom': {const photo=button.querySelector('img'),img=lightbox.querySelector('img');img.src=photo.src;img.alt=photo.alt;opener=button;lightbox.showModal();break;}
      case 'close': close(button.closest('dialog'));break;
    }
    if(button.closest('#mobile-nav')) {document.querySelector('#mobile-nav').classList.remove('open');document.querySelector('.menu-btn').setAttribute('aria-expanded','false');}
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelector('#mobile-nav')?.classList.remove('open');document.querySelector('.menu-btn')?.setAttribute('aria-expanded','false');}});
  for(const modal of [drawer,lightbox])modal?.addEventListener('click',e=>{if(e.target===modal){const r=modal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close(modal);}});
  document.addEventListener('change',event=>{
    const select=event.target.closest('[data-variant-select]');if(!select)return;
    const option=select.selectedOptions[0],panel=select.closest('.buy-copy');
    panel.querySelector('[data-product-price]').textContent=option.dataset.price;
    const button=panel.querySelector('[data-add-button]');button.disabled=option.dataset.available!=='true'||select.closest('form').dataset.selling!=='selling';button.textContent=button.disabled?'Uitverkocht':'In winkelmand ↗';
  });
  if(new URLSearchParams(location.search).get('onderwerp')==='retail') {const select=document.querySelector('#contact-topic');if(select)select.value='Retail / zakelijk';}
  const sticky=document.querySelector('.sticky-buy');
  if(sticky) {const update=()=>sticky.classList.toggle('visible',window.scrollY>600);window.addEventListener('scroll',update,{passive:true});update();}
})();
